import styled from '@emotion/styled';
import { useContext } from 'react';
import { store } from '../store';

const Grid = ({ size, color }) => {
  const { paperWidth, paperHeight, showGridLabels } = useContext(store);
  const cols = paperWidth / size;
  const rows = paperHeight / size;
  const totalSquares = cols * rows;
  const validColsRows = Number.isInteger(cols) && Number.isInteger(rows);

  return (
    validColsRows && (
      <GridContainer cols={cols} rows={rows}>
        {[...Array(totalSquares).keys()].map((item, i) => {
          const index = i + 1;
          const noBorderTop = index <= cols;
          const noBorderRight = index % cols === 0;
          const colNum = index % cols || cols;
          const rowNum = Math.ceil(index / cols);
          const label = `${rowNum} - ${colNum}`;
          return (
            <Square
              key={item}
              noBorderTop={noBorderTop}
              noBorderRight={noBorderRight}
              borderColor={color}
            >
              {showGridLabels && <SquareLabel>{label}</SquareLabel>}
            </Square>
          );
        })}
      </GridContainer>
    )
  );
};

const GridContainer = styled.div(({ cols, rows }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'grid',
  gridTemplateColumns: `repeat(${cols}, auto)`,
  gridTemplateRows: `repeat(${rows}, auto)`,
  pointerEvents: 'none',
}));

const Square = styled.div(
  {
    borderTop: '1px solid',
    borderRight: '1px solid',
    position: 'relative',
  },
  ({ borderColor, noBorderTop, noBorderRight }) => ({
    borderTop: noBorderTop ? 'none' : null,
    borderRight: noBorderRight ? 'none' : null,
    color: borderColor,
    borderColor,
  })
);

const SquareLabel = styled.div({
  position: 'absolute',
  top: 0,
  left: 0,
});

export default Grid;
